import React from 'react'
import NotificationAutoInterUpdator from '../../../NotificationAutoInterUpdator'
import { NotificationBodyWithAccessCard, NotificationViewModel } from '../../..'
import i18next from 'i18next'

const CampaignRemoveContributorNotif = (props) => {
  const { sender } = props
  NotificationAutoInterUpdator(props)
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <NotificationViewModel
      {...props}
      learningSectionContent={''}
      notificationBody={
        <NotificationBodyWithAccessCard
          {...props}
          notificationBodyContent={
            rtl
              ? `(ت)قام ${sender?.name} بحذفك من قائمة المشاركين و كذلك قناة المشاركة الخاصة بحملة ترويجية `
              : `${sender?.name} has removed you from his(her) project campaign contributors list and the associated channel`
          }
        />
      }
      buttonsArray={[]}
    />
  )
}

export default CampaignRemoveContributorNotif
